import { saveSharedEditHistory } from "@scripts/../backendapi/dataSharingApi";
import { useCurrentWorkspace } from "@/store";
import { useCallback } from "react";
import { Annotation } from "@/types/annotation";
import { MediaItem } from "@/types/media";
import { getImageExtension } from "@utils/imageUtils";
import { useVisibilityThroughWorkspace } from "./useVisibilityThroughWorkspace";

export enum ToolType {
    RAPID_TEXT_PROMPT = "rapid-text-prompt",
    RAPID_MANUAL_EDIT = "rapid-manual-edit"
}

type ToolData = {
    tool_type: ToolType;
    model_used: "sam3" | "owlv2";
    annotation_ids: string[];
    text_prompts: { text: string; confidence_threshold: number }[];
    training_images_count: number | undefined;
    prompt_boxes:
        | {
              image_id: string;
              cls: string;
              x: number;
              y: number;
              w: number;
              h: number;
              confidence: number;
              negative: boolean;
          }[]
        | undefined;
};

interface SaveSharedEditHistoryEntry {
    annotations: { boxes: Annotation[]; key: string; width: number; height: number };
    tool_data: ToolData;
}

export const useSaveSharedEditHistory = () => {
    const workspace = useCurrentWorkspace();
    const visibilityThroughWorkspace = useVisibilityThroughWorkspace();

    const saveSharedEditHistoryCallback = useCallback(
        async (mediaItem: MediaItem, entry: SaveSharedEditHistoryEntry) => {
            // Only save edit history for public workspaces
            if (visibilityThroughWorkspace !== "public") return;

            const downloadUrl =
                mediaItem.uploadResizedResult?.downloadUrl ||
                mediaItem.file.uploadResizedResult?.downloadUrl ||
                mediaItem.uploadResult?.downloadUrl ||
                mediaItem.file.uploadResult?.downloadUrl;
            if (!downloadUrl) {
                throw new Error("Image location not found");
            }
            const historyEntry = {
                ...entry,
                externalImageData: { imageUuid: mediaItem.id, imageLocation: downloadUrl },
                imageExtension: getImageExtension(mediaItem.file),
                projectId: "rapid",
                workspaceId: workspace?.id || "anonymous"
            };
            // Disabled until all edit history is saved correctly
            // return saveSharedEditHistory(historyEntry);
        },
        [workspace, visibilityThroughWorkspace]
    );

    return saveSharedEditHistoryCallback;
};
